import { render, staticRenderFns } from "./OrderSettlementForm.vue?vue&type=template&id=ff5d9f70&scoped=true&"
import script from "./OrderSettlementForm.vue?vue&type=script&lang=js&"
export * from "./OrderSettlementForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderSettlementForm.vue?vue&type=style&index=0&id=ff5d9f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5d9f70",
  null
  
)

export default component.exports